export const API = process.env.REACT_APP_API_URL;
export const SENTRY_DNS = process.env.SENTRY_DNS || '';
